import { codeMark } from "./codeMark.js";
const codeToolbarButton = {
  marks: { [codeMark]: true },
  label: "Code",
  title: "Code",
  blueprintIcon: "code"
};
export {
  codeToolbarButton
};
//# sourceMappingURL=codeToolbarButton.js.map
